<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 5h-3V3a1 1 0 00-1-1H7a1 1 0 00-1 1v2H3a1 1 0 00-1 1v12a1 1 0 001 1h3v2a1 1 0 001 1h10a1 1 0 001-1v-2h3a1 1 0 001-1V6a1 1 0 00-1-1zM8 4h8v1H8zm8 16H8v-6h8zm4-3h-2v-3a1 1 0 000-2H6a1 1 0 000 2v3H4V7h16z"/><path d="M16 8.5a.5.5 0 000 1h2a.5.5 0 000-1zM10 16.5h4a.5.5 0 000-1h-4a.5.5 0 000 1zM10 18.5h4a.5.5 0 000-1h-4a.5.5 0 000 1z"/></svg>